import axios from 'axios';

// Backend API - uses nginx proxy /api (same origin, no CORS)
const BACKEND_URL = process.env.REACT_APP_API_URL || '';

// n8n Webhook base URL - for data (school, presets, logs)
const N8N_URL = process.env.REACT_APP_N8N_URL || 'http://localhost:5678';
const N8N_WEBHOOK = `${N8N_URL}/webhook`;

const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
});

// Add token to all API requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const n8nApi = axios.create({
  baseURL: N8N_WEBHOOK,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Auth API ────────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
  me: () => api.get('/api/auth/me'),
};

// ─── School API → n8n → NocoDB ──────────────────────────────────
export const schoolAPI = {
  get: () => n8nApi.get('/school').catch(() => api.get('/api/school')),
  save: (school_name) => n8nApi.post('/school', { school_name }).catch(() => api.post('/api/school', { school_name })),
};

// ─── Presets API → Backend (PostgreSQL) - fast & reliable ────────
// n8n is used only for logging, not for presets CRUD
export const presetsAPI = {
  getAll: (school = '') => api.get(`/api/presets?school=${encodeURIComponent(school)}`),
  create: (data) => api.post('/api/presets', data),
  update: (id, data) => api.put(`/api/presets/${id}`, data),
  delete: (id) => api.delete(`/api/presets/${id}`),
};

// ─── WhatsApp API → Backend directly ────────────────────────────
export const whatsappAPI = {
  getQR: (session = 'default') =>
    api.get(`/api/whatsapp/qr?session=${session}`),
  getStatus: (session = 'default') =>
    api.get(`/api/whatsapp/status?session=${session}`),
  init: (session = 'default') =>
    api.post('/api/whatsapp/init', { session }),
};

// ─── Messages API → Backend (WhatsApp send) ─────────────────────
export const messagesAPI = {
  parseExcel: (formData) =>
    api.post('/api/parse-excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  sendMarks: (formData) =>
    api.post('/api/send-marks', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    }),

  downloadTemplate: () =>
    api.get('/api/download-template', { responseType: 'blob' }),

  generatePDF: (student, schoolName) =>
    api.post('/api/generate-pdf', { student, schoolName }, { responseType: 'blob' }),

  sendManual: (data) => api.post('/api/send-manual', data),
};

// ─── Logs API → n8n → NocoDB ────────────────────────────────────
export const logsAPI = {
  logSent: (data) => n8nApi.post('/log-sent', data).catch(() => {}), // non-blocking
  getLogs: () => n8nApi.get('/sent-logs'),
};

// ─── PDF Tools API → Backend ────────────────────────────────────
export const pdfToolsAPI = {
  compress: (formData) => api.post('/api/pdf/compress', formData, { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }),
  merge: (formData) => api.post('/api/pdf/merge', formData, { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }),
};

export default api;
